import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { DragDropContainer } from 'react-drag-drop-container';
import { Stage, Layer } from 'react-konva';

import { GenericComponentCanvas } from "./componentCanvas/GenericComponentCanvas";

class DraggableLayoutComponent extends React.Component {
    render() {
        const { dimentionsRatio, component, isSelected, onDrag } = this.props;

        return (
            <div className="drag-drop-container" id={`drag-${component.type.toLowerCase()}`}>
                <DragDropContainer targetKey="layoutBuilder"
                    dragClone={true}
                    dragData={component}
                    onDrag={onDrag}>
                    <Stage width={151} height={41} style={{ cursor: "pointer" }}>
                        <Layer>
                            <GenericComponentCanvas
                                isSelected={isSelected}
                                geometry={component.geometries[0]}
                                component={component}
                                dimentionsRatio={dimentionsRatio}
                                draggable={false} />
                        </Layer>
                    </Stage>
                </DragDropContainer>
            </div>
        );
    }
}

export class AvailableComponentsCanvas extends Component {
    onDragMethod(dragData, currentTarget, positionAxisX, positionAxisY) {
        const { layout } = this.props;

        if (layout.isOver) {
            dragData.geometries[0].positionAxisX = positionAxisX - currentTarget.getBoundingClientRect().x;
            dragData.geometries[0].positionAxisY = positionAxisY - currentTarget.getBoundingClientRect().y;
        }
    }

    render() {
        const { availableComponents, selectedComponentInternalType } = this.props;

        const availableComponentsElements = [];
        for (const idx in availableComponents) {
            availableComponentsElements.push(
                <DraggableLayoutComponent
                    isSelected={selectedComponentInternalType === availableComponents[idx].type}
                    key={idx}
                    component={availableComponents[idx]}
                    dimentionsRatio={1}
                    onDrag={(a, b, c, d) => this.onDragMethod(a, b, c, d)} />
            );
        }

        return (
            <Grid fluid>
                <Row>
                    <Col className="no-padding-left" sm={12}>
                        <div className="control-label">Configuração</div>
                        <small>(arraste os elementos para a folha de trabalho)</small>
                    </Col>
                </Row>
                <Row>
                    <Col className="no-padding-left" sm={12}>
                        {availableComponentsElements}
                    </Col>
                </Row>
            </Grid>
        );
    }
}
